import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {service} from '../redux/service'

interface Props {
  id: string
  handleClose: () => void
}

const Field = ({label, value}: {label: string; value?: string | number | boolean | null}) => (
  <div className='col-md-4 mb-3'>
    <div className='text-muted small'>{label}</div>
    <div className='fw-semibold'>
      {typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value ?? '-'}
    </div>
  </div>
)

const SectionHeading = ({title}: {title: string}) => (
  <div className='col-12 mt-3 mb-2'>
    <h6 className='text-primary border-bottom pb-1 mb-0'>{title}</h6>
  </div>
)

const ViewCreditCardApplicationDetails = ({id, handleClose}: Props) => {
  const [application, setApplication] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    service
      .getCreditCardApplicationReportDetail(id)
      .then((res) => setApplication(res.data?.data))
      .catch(() => toast.error('Failed to load credit card application details.'))
      .finally(() => setLoading(false))
  }, [id])

  const gi = application?.general_information
  const pi = application?.personal_information
  const doc = application?.document

  return (
    <div className='modal show d-block' style={{background: 'rgba(0,0,0,0.5)'}}>
      <div className='modal-dialog modal-xl modal-dialog-scrollable'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              Credit Card Application — {application?.request_code || id}
            </h5>
            <button className='btn-close' onClick={handleClose} />
          </div>
          <div className='modal-body'>
            {loading ? (
              <div className='text-center py-5'>
                <div className='spinner-border text-primary' />
              </div>
            ) : !application ? (
              <div className='alert alert-danger'>Application not found.</div>
            ) : (
              <>
                <div className='row mb-3'>
                  <Field label='Request Code' value={application.request_code} />
                  <Field label='Application Step' value={application.application_step} />
                  <Field label='Application Status' value={application.application_status} />
                  <Field label='OTP Status' value={application.otp_status} />
                  <Field label='Initiated' value={application.initiation_date_time} />
                  <Field label='Submitted' value={application.submission_date_time} />
                </div>

                <div className='row'>
                  <SectionHeading title='General Information' />
                  <Field
                    label='Full Name'
                    value={[gi?.first_name, gi?.middle_name, gi?.last_name]
                      .filter(Boolean)
                      .join(' ')}
                  />
                  <Field label='Mobile Number' value={gi?.mobile_number} />
                  <Field label='Email Address' value={gi?.email_address} />
                  <Field label='Card Type' value={gi?.card_type} />
                  <Field label='Gender' value={gi?.gender} />
                  <Field label='Citizenship Number' value={gi?.citizenship_number} />
                  <Field label='Marital Status (legacy)' value={gi?.legacy_marital_status_label} />
                  <Field label='Education Level (legacy)' value={gi?.legacy_education_level_label} />
                  <Field label='Reference Name' value={gi?.reference_name} />
                  <Field label='Reference Contact' value={gi?.reference_contact_number} />

                  <SectionHeading title='Personal Information' />
                  <Field label="Father's Name" value={pi?.father_name} />
                  <Field label="Mother's Name" value={pi?.mother_name} />
                  <Field label='Permanent Municipality' value={pi?.permanent_municipality} />
                  <Field label='Permanent Tole/Street' value={pi?.permanent_tole_street} />
                  <Field label='Office Name' value={pi?.office_name} />
                  <Field label='Office Address' value={pi?.office_address} />

                  <SectionHeading title='Documents & Consents' />
                  <Field label='Passport Size Photo' value={doc?.passport_size_photo} />
                  <Field label='Signature' value={doc?.signature} />
                  <Field label='Citizenship' value={doc?.citizenship} />
                  <Field label='Income Documents' value={doc?.income_documents} />
                  <Field label='Supporting Documents' value={doc?.supporting_documents} />
                  <Field label='Accepted Disclaimer' value={doc?.accept_disclaimer} />
                  <Field label='Accepted Debit Authority' value={doc?.accept_debit_authority} />
                  <Field label='Accepted Sub Fee Payment Plan' value={doc?.accept_sub_fee_payment_plan} />
                  <Field label='Accepted Terms & Conditions' value={doc?.accept_terms_conditions} />
                </div>
              </>
            )}
          </div>
          <div className='modal-footer'>
            <button className='btn btn-secondary btn-sm' onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewCreditCardApplicationDetails
